<div class="dialog" fxLayout="column">

  <div mat-dialog-header>
    <div class="dialog-title" fxLayout="row" fxLayoutAlign="space-between end">
      <div fxLayout="row" fxLayoutGap="10px">
        <mat-icon>create</mat-icon>
        <h1>{{'予約状況：編集' | translate}}</h1>
      </div>

      <div fxLayout="row" fxLayoutGap="8px">
        <button mat-raised-button color="primary" (click)="addReservation()" [disabled]="!reservationFormGroup.valid || reservationStatusControl.value === RESERVATION_STATUS_RECEPTION">
          <mat-icon>add</mat-icon>
          <span>{{'更新' | translate}}</span>
        </button>
        <button mat-button (click)="onNoClick()">
          <mat-icon>clear</mat-icon>
        </button>
      </div>
    </div>
  </div>

  <div mat-dialog-content>
    <div class="dialog-body" fxLayout="row" fxLayoutGap="24px">

      <div class="dialog-left" fxLayout="column" fxLayoutGap="20px" fxFlex="100%">
        <form class="form" [formGroup]="reservationFormGroup">
          <div fxLayout="row" fxLayoutGap="20px">
            <div fxFlex="50%">
              <label>{{'予約番号' | translate}}</label>
              <div *ngIf="!!reservation && reservation.reservation_no">
                {{ reservation.reservation_no }}
              </div>
            </div>
            <div fxFlex="50%">
              <label>{{'展示ID' | translate}}</label>
              <div *ngIf="!!reservation && reservation.exhibit_id">
                {{ reservation.exhibit_id }}
              </div>
            </div>
          </div>
          <br>
          <div fxLayout="row" fxLayoutGap="20px">
            <div fxFlex="50%">
              <label>{{'予約施設' | translate}}</label>
              <div *ngIf="!!reservationFacilities">
                <div *ngFor="let reservationFacility of reservationFacilities">
                  <div
                    *ngIf="!!reservation && reservation.reservation_facility_id === reservationFacility.reservation_facility_id">
                    {{ reservationFacility.reservation_facility_names | multiName:projectLanguages:projectBaseLang }}
                  </div>
                </div>
              </div>
            </div>
            <div fxFlex="50%">
              <label>{{'属性' | translate}}</label>
              <div *ngFor="let reservationFacilityAttribute of (reservationFacilityAttributes | async)">
                <div
                  *ngIf="!!reservation && reservation.reservation_facility_attribute_id === reservationFacilityAttribute.attribute_id">
                  {{ reservationFacilityAttribute.attribute_names | multiName:projectLanguages:projectBaseLang }}
                </div>
              </div>
            </div>
          </div>
          <br>
          <div fxLayout="row" fxLayoutGap="20px">
            <div fxFlex="50%">
              <label>{{'利用日' | translate}}</label>
              <div *ngIf="!!reservation && reservation.reservation_start_date">
                {{ reservation.reservation_start_date.seconds * 1000 | date: 'yyyy/MM/dd' }}
              </div>
            </div>
            <div fxFlex="50%">
              <label>{{'利用日(延泊)' | translate}}</label>
              <div *ngIf="!!reservation && reservation.reservation_end_date">
                {{ reservation.reservation_end_date.seconds * 1000 | date: 'yyyy/MM/dd' }}
              </div>
            </div>
          </div>
          <br>
          <div fxLayout="row" fxLayoutGap="20px">
            <div fxFlex="50%">
              <label>{{'利用時間' | translate}}</label>
              <div *ngIf="!!reservation && reservation.reservation_times">
                <div *ngFor="let reservation_time of reservation.reservation_times">
                  {{ reservation_time.item }}
                </div>
              </div>
            </div>
          </div>
          <br>
          <div fxLayout="row" fxLayoutGap="20px">
            <div fxFlex="50%">
              <label>{{'SPLATS QRコード' | translate}}</label>
              <div *ngIf="!!reservation && reservation.splats_qr_code">
                {{ reservation.splats_qr_code }}
              </div>
            </div>
            <div fxFlex="50%">
              <label>{{'SPLATS ゲストID' | translate}}</label>
              <div *ngIf="!!reservation && reservation.splats_guest_id">
                {{ reservation.splats_guest_id }}
              </div>
            </div>
          </div>
          <br>
          <div fxLayout="row" fxLayoutGap="20px">
            <div fxFlex="50%">
              <label>{{'登録日時' | translate}}</label>
              <div *ngIf="!!reservation && reservation.created">
                {{ reservation.created.seconds * 1000 | date: 'yyyy/MM/dd HH:mm:ss' }}
              </div>
            </div>
            <div fxFlex="50%">
              <label>{{'更新日時' | translate}}</label>
              <div *ngIf="!!reservation && reservation.updated">
                {{ reservation.updated.seconds * 1000 | date: 'yyyy/MM/dd HH:mm:ss' }}
              </div>
            </div>
          </div>
          <br>
          <div *ngIf="!!reservation && reservation.reservation_cancel_date" fxLayout="row" fxLayoutGap="20px">
            <div fxFlex="50%">
              <label>{{'キャンセル日時' | translate}}</label>
              <div>
                {{ reservation.reservation_cancel_date.seconds * 1000 | date: 'yyyy/MM/dd HH:mm:ss' }}
              </div>
            </div>
            <div fxFlex="50%">
              <label>{{'キャンセル実行者' | translate}}</label>
              <div *ngIf="!!reservation && reservation.reservation_cancel_user">
                {{ reservation.reservation_cancel_user }}
              </div>
            </div>
          </div>
          <br *ngIf="!!reservation && reservation.reservation_cancel_date">
          <div fxLayout="row" fxLayoutGap="20px">
            <div fxFlex="50%">
              <label>{{'メール送信状況' | translate}}</label>
              <div *ngFor="let mailSendStatus of mailSendStatuses">
                <div *ngIf="!!reservation && reservation.mail_send_status === mailSendStatus">
                  {{ mailSendStatus | mailSendStatus }}
                </div>
              </div>
            </div>
          </div>
          <br>
          <div fxLayout="row" fxLayoutGap="20px">
            <mat-form-field fxFlex="50%"
              *ngIf="[RESERVATION_STATUS_RECEPTION].includes(reservation?.reservation_status!)">
              <mat-label>{{'予約状況' | translate}}</mat-label>
              <mat-select placeholder="{{'予約状況' | translate}}" id="reservationStatus"
                formControlName="reservationStatus">
                <mat-option [value]="RESERVATION_STATUS_RECEPTION">{{ RESERVATION_STATUS_RECEPTION | reservationStatus
                  }}</mat-option>
                <mat-option [value]="RESERVATION_STATUS_COMPLETE">{{ RESERVATION_STATUS_COMPLETE | reservationStatus
                  }}</mat-option>
                <mat-option [value]="RESERVATION_STATUS_LOST">{{ RESERVATION_STATUS_LOST | reservationStatus
                  }}</mat-option>
              </mat-select>
              <mat-error *ngIf="reservationStatusControl.invalid">{{ getErrorMessageToReservationStatus() }}</mat-error>
            </mat-form-field>
            <div fxFlex="50%" *ngIf="![RESERVATION_STATUS_RECEPTION].includes(reservation?.reservation_status!)">
              <label>{{'予約状況' | translate}}</label>
              <div *ngFor="let reservationStatus of reservationStatuses">
                <div *ngIf="!!reservation && reservation.reservation_status === reservationStatus">
                  {{ reservationStatus | reservationStatus }}
                </div>
              </div>
            </div>
          </div>
          {{'▼メモ' | translate}}
          <div fxLayout="row" fxLayoutGap="20px">
            <mat-form-field fxFlex="100%">
              <textarea matInput type="text" placeholder="" rows="5" formControlName="memo"></textarea>
            </mat-form-field>
          </div>
          <br>
        </form>
      </div>


      <div class="dialog-right" fxLayout="column" fxLayoutGap="10px" fxFlex="100%">
        <div fxLayout="row" fxLayoutGap="20px" class="view-row">
          {{'▼基本項目' | translate}}
        </div>
        <div fxLayout="row" fxLayoutGap="20px" class="view-row">
          <div fxFlex="50%">
            <label>{{'メールアドレス' | translate}}</label>
            <div>
              {{ reservation?.email_address }}
            </div>
          </div>
          <div fxFlex="50%">
            <ng-container *ngIf="reservationFacility.is_visibled_mobile_phone_number">
              <label>{{'携帯電話番号' | translate}}</label>
              <div>
                {{ reservation?.mobile_phone_number }}
              </div>
            </ng-container>
          </div>
        </div>
        <div fxLayout="row" *ngIf="reservationFacility.is_visibled_company_name" fxLayoutGap="20px" class="view-row">
          <div fxFlex="100%">
            <ng-container *ngIf="reservationFacility.is_visibled_company_name">
              <label>{{'会社名' | translate}}</label>
              <div>
                {{ reservation?.company_name }}
              </div>
            </ng-container>
          </div>
        </div>
        <div fxLayout="row" fxLayoutGap="20px" class="view-row"
          *ngIf="reservationFacility.is_visibled_department || reservationFacility.is_visibled_job_title">
          <div fxFlex="50%">
            <ng-container *ngIf="reservationFacility.is_visibled_department">
              <label>{{'部署' | translate}}</label>
              <div>
                {{ reservation?.department }}
              </div>
            </ng-container>
          </div>
          <div fxFlex="50%">
            <ng-container *ngIf="reservationFacility.is_visibled_job_title">
              <label>{{'役職' | translate}}</label>
              <div>
                {{ reservation?.job_title }}
              </div>
            </ng-container>
          </div>
        </div>
        <div fxLayout="row" fxLayoutGap="20px" class="view-row"
          *ngIf="reservationFacility.is_visibled_surname_chinese || reservationFacility.is_visibled_name_chinese">
          <div fxFlex="50%">
            <ng-container *ngIf="reservationFacility.is_visibled_surname_chinese">
              <label>{{'姓（漢字）' | translate}}</label>
              <div>
                {{ reservation?.surname_chinese }}
              </div>
            </ng-container>
          </div>
          <div fxFlex="50%">
            <ng-container *ngIf="reservationFacility.is_visibled_name_chinese">
              <label>{{'名（漢字）' | translate}}</label>
              <div>
                {{ reservation?.name_chinese }}
              </div>
            </ng-container>
          </div>
        </div>
        <div fxLayout="row" fxLayoutGap="20px" class="view-row"
          *ngIf="reservationFacility.is_visibled_family_name || reservationFacility.is_visibled_first_name">
          <div fxFlex="50%">
            <ng-container *ngIf="reservationFacility.is_visibled_family_name">
              <label>{{'姓（カナ）' | translate}}</label>
              <div>
                {{ reservation?.family_name }}
              </div>
            </ng-container>
          </div>
          <div fxFlex="50%">
            <ng-container *ngIf="reservationFacility.is_visibled_first_name">
              <label>{{'名（カナ）' | translate}}</label>
              <div>
                {{ reservation?.first_name }}
              </div>
            </ng-container>
          </div>
        </div>
        <div fxLayout="row" fxLayoutGap="20px" class="view-row"
          *ngIf="reservationFacility.is_visibled_birthday || reservationFacility.is_visibled_gender">
          <div fxFlex="50%">
            <ng-container *ngIf="reservationFacility.is_visibled_family_name">
              <label>{{'生年月日' | translate}}</label>
              <div>
                <ng-container *ngIf="!!reservation?.birthday">
                  {{ reservation!.birthday.seconds * 1000 | date: 'yyyy-MM-dd' }}
                </ng-container>
              </div>
            </ng-container>
          </div>
          <div fxFlex="50%">
            <ng-container *ngIf="reservationFacility.is_visibled_gender">
              <label>{{'性別' | translate}}</label>
              <div>
                <ng-container *ngIf="!!reservation?.gender">
                  {{ reservation!.gender | gender }}
                </ng-container>
              </div>
            </ng-container>
          </div>
        </div>
        <div *ngIf="reservationFacility.is_visibled_address" fxLayout="row" fxLayoutGap="20px" class="view-row">
          <div fxFlex="50%">
            <label>{{'郵便番号' | translate}}</label>
            <div>
              {{ reservation?.postal_code }}
            </div>
          </div>
        </div>
        <div *ngIf="reservationFacility.is_visibled_address" fxLayout="row" fxLayoutGap="20px" class="view-row">
          <div fxFlex="50%">
            <label>{{'都道府県' | translate}}</label>
            <div>
              {{ reservation?.prefecture }}
            </div>
          </div>
          <div fxFlex="50%">
            <label>{{'市区町村' | translate}}</label>
            <div>
              {{ reservation?.municipalities }}
            </div>
          </div>
        </div>
        <div *ngIf="reservationFacility.is_visibled_address" fxLayout="row" fxLayoutGap="20px" class="view-row">
          <div fxFlex="50%">
            <label>{{'町名番地' | translate}}</label>
            <div>
              {{ reservation?.street_address }}
            </div>
          </div>
          <div fxFlex="50%">
            <label>{{'建物名・号室' | translate}}</label>
            <div>
              {{ reservation?.name_and_number_building }}
            </div>
          </div>
        </div>
        <div *ngIf="reservationFacility.is_visibled_user_request && !!reservationFacilities" class="view-row">
          <div *ngFor="let reservationFacility of reservationFacilities">
            <div
              *ngIf="!!reservation && reservation.reservation_facility_id === reservationFacility.reservation_facility_id">
              <label>{{ reservationFacility.reservation_user_input_titles |
                multiUserInputTitle:projectLanguages:projectBaseLang }}</label>
            </div>
          </div>
          <div>
            <span *ngIf="!!reservation?.user_request" [innerHTML]="reservation!.user_request | html"></span>
          </div>
        </div>

        <div *ngIf="questions && questions.length > 0 && reservation">
          <div fxLayout="row" fxLayoutGap="20px" class="view-row">
            {{'▼カスタム項目' | translate}}
          </div>
          <div *ngFor="let answer of reservation.answer; let i = index">
            <div fxLayout="row" fxLayoutGap="20px" class="view-row">
              <div fxFlex="100%">
                <label>{{ questions[i].question_names[0].name }}</label>
                <div>
                  <!-- string -->
                  <ng-container *ngIf="questions[i].question_type === 'string'">
                    {{ answer.value }}
                  </ng-container>
                  <!-- text-area -->
                  <ng-container *ngIf="questions[i].question_type === 'text-area'">
                    <span [innerHTML]="answer.value | html"></span>
                  </ng-container>
                  <!-- number -->
                  <ng-container *ngIf="questions[i].question_type === 'number'">
                    {{ answer.value }}
                  </ng-container>
                  <!-- select -->
                  <ng-container *ngIf="questions[i].question_type === 'select'">
                    <ng-container *ngFor="let item of questions[i].question_select_items">
                      <ng-container *ngIf="answer.value === item.value">
                        {{ item.items[0].item }}
                      </ng-container>
                    </ng-container>
                  </ng-container>
                  <!-- checkbox -->
                  <ng-container *ngIf="questions[i].question_type === 'checkbox'">
                    <div fxLayout="row">
                      <ng-container *ngFor="let item of questions[i].question_select_items">
                        <ng-container *ngFor="let value of answer.value; let j = index">
                          <ng-container *ngIf="value === item.value">
                            <ng-container *ngIf="j !== 0">
                              <br>
                            </ng-container>
                            {{ item.items[0].item }}
                          </ng-container>
                        </ng-container>
                      </ng-container>
                    </div>
                  </ng-container>
                  <!-- radio -->
                  <ng-container *ngIf="questions[i].question_type === 'radio'">
                    <ng-container *ngFor="let item of questions[i].question_select_items">
                      <ng-container *ngIf="answer.value === item.value">
                        {{ item.items[0].item }}
                      </ng-container>
                    </ng-container>
                  </ng-container>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>


    </div>
  </div>
</div>

